<template>
  <div>
    <AdminMasterLayout>
      <div class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <i
                    class="fa fa-users primary-color"
                    aria-hidden="true"
                    style="font-size: 35px"
                  ></i>
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.iUsers.manageUsers") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.iUsers.usersAndRoles") }}
                </p>
              </div>
              <div class="col-md-5 flexify" v-if="!$route.query.groupId">
                <router-link
                  :to="{
                    name: 'industrial_admin_create_users',
                    query: { companyID: $route.query.companyID },
                  }"
                  class="mr-3 btn dealers_btn"
                  >{{ $t("text.iUsers.createUsers") }}
                </router-link>
                <button
                  class="btn dealers_btn"
                  @click="openModal('addOldUser')"
                >
                  {{ $t("text.iUsers.addExistingUser") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.iUsers.title") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <i
                          class="text-white fa fa-users"
                          aria-hidden="true"
                          style="font-size: 35px"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ usersCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :rowDataBound="rowDataBound"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  width="200"
                  field="firstName"
                  :headerText="$t('text.iUsers.firstName')"
                ></e-column>
                <e-column
                  width="150"
                  field="lastName"
                  :headerText="$t('text.iUsers.lastName')"
                ></e-column>
                <e-column
                  width="250"
                  field="email"
                  :headerText="$t('text.iUsers.email')"
                ></e-column>
                <e-column
                  width="200"
                  :template="UserStatusTemp"
                  :headerText="$t('text.iUsers.status')"
                ></e-column>
                <e-column
                  width="200"
                  field="status"
                  :visible="false"
                ></e-column>

                <e-column
                  v-if="this.$route.query.groupId"
                  width="150"
                  field="roleCategory"
                  :headerText="$t('text.iUsers.accessLevel')"
                ></e-column>

                <e-column
                  v-else
                  width="150"
                  field="rolesCategory"
                  :headerText="$t('text.iUsers.accessLevel')"
                ></e-column>

                <e-column
                  width="250"
                  :template="UsersTemplate"
                  headerText=""
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </AdminMasterLayout>
    <AddOldUserModal :company="company" :users="users" :companyID="companyID" />
  </div>
</template>

<script>
import Vue from "vue";
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
import UserStatusTemp from "@/components/Templates/userStatusTemp";
import AddOldUserModal from "@/components/modals/addOldUser";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Users :: Epump Portal",
  name: "Users",
  components: {
    AdminMasterLayout,
    TableLoader,
    AddOldUserModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      company: null,
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : this.$route.query.companyID,
      groupId: null,
      backgroundUrl,
      usersCount: 0,
      cardBackgroundUrl,
      showLoader: true,
      users: [],
      unmapFromG: {},
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      UsersTemplate: function () {
        return {
          template: CompanyUsersTemplate,
        };
      },
      UserStatusTemp: function () {
        return {
          template: UserStatusTemp,
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getCompanyUsers();
      }
    },
    $route(to, from) {
      if (from.query.groupId && !to.query.groupId) {
        this.getBranches();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyID) {
      this.getCompanyUsers();
      this.companyId = localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : this.$route.query.companyID;
      // console.log(this.companyId);
    }
    this.$eventHub.$on("unmapFromGroup", (data) => {
      this.unmapFromG = data;
      this.unmapUserGroup();
    });
    this.$eventHub.$on("getCUsers", () => {
      this.getCompanyUsers();
    });
    this.$eventHub.$on("getCUsersModal", (emailP) => {
      // console.log(emailP);
      this.getCompanyUsers();
      // const idedUser = [];
      const particularUser = this.users.filter((cur) => cur.email === emailP);
      const idedUser = particularUser[0];
      // console.log(particularUser[0]);
      this.$router.push({
        name: "industrial_admin_user_details",
        query: {
          userId: idedUser.ownerId,
          username: idedUser.email,
          name: `${idedUser.firstName} ${idedUser.lastName}`,
          companyID: this.$route.query.companyID
            ? this.$route.query.companyID
            : this.companyID,
        },
      });
      // this.$eventHub.$emit("group", this.group);
    });
    if (this.$route.query.companyID) {
      this.getCompanyUsers();
    }
    if (this.$route.query.groupId) {
      this.getCompanyUsers();
    }
  },
  beforeDestroy() {
    this.$eventHub.$off("unmapFromGroup");
    this.$eventHub.$off("getCUsers");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.groupId = this.$route.query.groupId;
  },
  methods: {
    openModal($modal) {
      this.$modal.show($modal);
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Users.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    rowDataBound: function (args) {
      if (args.data["status"] === "Active") {
        args.row.cells[4].style.color = "green";
      }
      if (args.data["status"] === "Deactivated") {
        args.row.cells[4].style.color = "blue";
      }
      if (args.data["status"] === "Suspended") {
        args.row.cells[4].style.color = "red";
      }
    },
    unmapUserGroup() {
      // console.log(this.unmapFromG);
      // this.showLoader = true;
      const confirm = window.confirm(
        `Are you sure you want to remove ${this.unmapFromG.email} ?`
      );
      if (!confirm) {
        return;
      }
      const data = {
        groupId: this.$route.query.groupId,
        userId: this.unmapFromG.id,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/GroupManagement/UnmapUserGroup`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: `(${this.unmapFromG.email}) has been unmapped successfully`,
            type: "success",
            duration: 3000,
          });
          if (this.usersCount > 1) {
            this.getCompanyUsers();
          } else {
            this.$router.push({
              name: "industrial_admin_group_management",
              query: {
                companyID: this.$route.query.companyID
                  ? this.$route.query.companyID
                  : companyID,
              },
            });

            // this.showLoader = false;
            this.$eventHub.$emit("getGPM");
            // this.isButtonDisabled = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
          // this.isButtonDisabled = false;
          // this.showLoader = false;
        });
    },
    getCompanyUsers() {
      this.showLoader = true;
      let url = "";
      if (this.$route.query.groupId) {
        url = `${configObject.apiBaseUrl}/GroupManagement/Users/${this.$route.query.groupId}`;
      } else {
        url = `${configObject.apiBaseUrl}/Company/Usersv2/${
          this.$route.query.companyID
            ? this.$route.query.companyID
            : this.companyID
        }`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          sessionStorage.clear();
          localStorage.setItem(
            "industryUsersList",
            JSON.stringify(response.data)
          );
          response.data.forEach((user, index) => {
            user.rolesCategory = user.rolesCategory
              ? user.rolesCategory
              : "N/A";
            user.index = index + 1;
            user.forcePasswordChange = user.forcePasswordChange ? "Yes" : "No";
          });
          this.usersCount = response.data.length;
          this.showLoader = false;
          this.users = response.data;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
